import CustomCard from '@/components/customCard';
import CustomGridLayoutPreview from '@/components/CustomGridLayoutPreview';
import BaseImage from '@/components/Icons/BaseImage';
import { PATH } from '@/constants/path';
import useUserPlan from '@/hooks/useUserPlan';
import { CustomizeAppearanceCardStyled } from '@/pages/Checkout/components/CustomizeAppearanceCard/styled';
import { Badge } from '@shopify/polaris';
import { ArrowRightIcon } from '@shopify/polaris-icons';
import { useNavigate } from 'react-router-dom';

interface IProps {
  title?: string | React.ReactElement;
  isEmptyCheckoutMethod: boolean;
  children?: React.ReactNode;
  imgSrc: string;
  badgeHeader?: React.ReactNode;
}

export default function CustomizeAppearanceCard({ title, isEmptyCheckoutMethod, imgSrc, badgeHeader, children }: IProps) {
  const navigate = useNavigate();
  const { isEnableCheckout } = useUserPlan();

  return (
    <CustomizeAppearanceCardStyled>
      <CustomCard
        title={title}
        textClassName="ot-polaris-text-18"
        badgeHeader={
          isEmptyCheckoutMethod ? (
            <div
              className="ot-wrap-reverser-badge-content cursor-pointer"
              onClick={() => {
                isEnableCheckout && navigate(PATH.CREATE_CHECKOUT_EXTENSION);
              }}
            >
              <Badge icon={ArrowRightIcon} tone="attention">
                Create a checkout rule first
              </Badge>
            </div>
          ) : (
            badgeHeader ?? null
          )
        }
      >
        <CustomGridLayoutPreview>
          {children}
          <div className="d-flex">
            <BaseImage style={{ objectFit: 'contain', maxHeight: '340px' }} src={imgSrc} alt="preview" />
          </div>
        </CustomGridLayoutPreview>
      </CustomCard>
    </CustomizeAppearanceCardStyled>
  );
}
